/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
      "video_360_url" : $("#video_360_url").val(),
      "size" : $(this).data("carat")
    }];
    localStorage.setItem("diamond", JSON.stringify(diamond));
  localStorage.setItem('setting_filters_shape', $(this).data("shape"));
  localStorage.setItem('disable_setting_add_to_cart' , 0)
    setSteps("diamond");
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});


/****** end of choose diamond *****/

/******* Choose Setting function start ******/
function makeUpperCaseAfterCommas(str) {
    return str.replace(/,\s*([a-z])/g, function(d,e) { return ","+e.toUpperCase() });
}
$(document).on("click", ".choose-setting", function() {
        $(".product-media-modal").removeAttr("open");
    $("body.tps_ringbuilder_detail_page").removeClass("tps_model_popup");
	if($('#ringsize').val() == '')
    {
      alert("PLEASE SELECT RING SIZE ");
      return false;
    }
    var selected_diamond = localStorage.getItem("diamond");
    if(selected_diamond != null || selected_diamond != undefined){
      var ring_selected_min_size = parseFloat($("#minimum_carat_total_weight").val());
      var ring_selected_max_size = parseFloat($("#maximum_carat_total_weight").val());
  
      console.log("min Size"+ ring_selected_min_size + 'max size ' + ring_selected_max_size);
      selected_diamond = JSON.parse(selected_diamond);
      var selected_size = parseFloat(selected_diamond[0].size);
      console.log('selected_size',selected_size);   
  
      if (!isNaN(selected_size) && !isNaN(ring_selected_min_size) && !isNaN(ring_selected_max_size)){
          if (selected_size >= ring_selected_min_size && selected_size <= ring_selected_max_size) {
             
          } else {
            alert("The selected diamond carat is not compatible with the ring you have chosen. Please select a diamond with a different carat.");
             return false;
          }
      } else {
          console.error("Invalid values detected");
      }
    }
    var setting = [{
        "product_id": $("#product_id").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(),
        "setting_price": $("#variant_price").val(),
        "setting_metal_type": $("#variant_option1").val(),
        "setting_ring_size": $('#ringsize').val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
        "stock_num": $("#stock_num").val(),
        "no_of_center_stone": $("#no_of_center_stone").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "meta_metal": $("#meta-metal").val(),
        "center_stone": $("#center_stone").val(),
        "can_be_match_with":makeUpperCaseAfterCommas( $("#can_be_match_with").val()),
      	"image": $("#stockimg0").attr("src"),
      "setting_style": $("#setting_style").val(),
      "product_description": $("#product_description").val(),
      "side_stone_weight" : $("#side-stone-weight").val(),
      "pave_stone_weight" : $("#pave-stone-weight").val(),
      "vendor_code": $("#vendor_code").val().trim(),

    }];
  
  localStorage.setItem('disable_setting_add_to_cart' , 0)
  localStorage.setItem("ringbuilder_dia_shape", makeUpperCaseAfterCommas( $("#can_be_match_with").val()));
    localStorage.setItem("setting", JSON.stringify(setting));
  var currency_code = $('#currency_form select').val();
  localStorage.setItem('selected_currency' , currency_code);
    setSteps("setting");
});
/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) {
    if (localStorage.getItem("setting") && localStorage.getItem("diamond")) {
        localStorage.setItem("step3", "final ring");
        var setting_info = JSON.parse(localStorage.getItem("setting"));
        var diamond_info = JSON.parse(localStorage.getItem("diamond"));
      	var diamond_price = (diamond_info[0].diamond_price);
      	var currency_rate = Shopify.currency.rate;
          var  dia_price = diamond_price * currency_rate; 
        var final_price = parseFloat(setting_info[0].setting_price/100) + parseFloat(dia_price);
      	final_price = parseFloat(final_price).toFixed(2);
      	final_price = Math.ceil(final_price) * 100;
        localStorage.setItem("final_ring_price", final_price);
        window.location.href = tps_config.urls.ring_builder_final_page+"?diamond_select=true&setting_select=true"  //"/pages/final-ring";

    } else if (current_step == "diamond" && localStorage.getItem("setting")) {
        localStorage.setItem("step2", "diamond");
        window.location.href = tps_config.urls.ring_builder_final_page+"?diamond_select=true"//"/pages/final-ring";
    } else if (current_step == "setting" && localStorage.getItem("diamond")) {
        localStorage.setItem("step2", "setting");
        window.location.href = tps_config.urls.ring_builder_final_page+"?diamond_select=true&setting_select=true"// "/pages/final-ring";
    } else if (current_step == "diamond" && !localStorage.getItem("setting")) {
        localStorage.setItem("step1", "diamond");
        localStorage.setItem("step2", "setting");
        window.location.href = tps_config.urls.ring_builder_listing+"?setting_select=true" // "/collections/engagement-ringbuilder";
    } else if (current_step == "setting" && !localStorage.getItem("diamond")) {
        localStorage.setItem("step1", "setting");
        localStorage.setItem("step2", "diamond");
        window.location.href =  tps_config.urls.ringbuilder_loose_diamond+"?diamond_select=true" //"/pages/ringbuilder-loose-diamond";
    }


}


// $(document).ready(function() {

  
//   if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
//   }else{
//     if(localStorage.getItem("setting") || localStorage.getItem("diamond")){
//     	 localStorage.removeItem("diamond");
//     localStorage.removeItem("setting");
//     localStorage.removeItem("final_price");
//     localStorage.removeItem("ringbuilder_dia_shape");
//     localStorage.removeItem("step1");
//     localStorage.removeItem("step2");
//     localStorage.removeItem("step3");
//     window.location.href = tps_config.urls.ring_builder_listing;
//     }
    
//   }
//     // window.location.href = "/collections/ring-builder-engagement-rings-1";
// });
/*** set currenct step and redirect to next step end ****/



function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}